import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Table as DefectManagementTable,
    Thead,
    Tbody,
    Tr,
    Th
} from 'react-super-responsive-table';
import _ from 'lodash';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Row from './Row';
import ModalCustom from "../design/shared/modal";
import DefectSummary from "./DefectSummary/DefectSummary";
import { customStyles } from "./css";
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Table = ({ setFetchData, header = {}, data = [], userProfile, defectId, onDefectSelected }) => {
    const local = useLocaleContext()
    const { DEFECT_MANAGEMENT: { VIEW_DEFECT = '' } = {} } = local === 'en-US' ? EN : FR;

    const [selectedDefect, setSelectedDefect] = useState({});
    const [openModal, setOpenModal] = useState(false);
    let HEADER = []
    if (userProfile.role.name === 'ADMIN') {
        HEADER = ['DEFECT_ID', 'REPORTED_ON', 'DAYS_OPEN', 'WEBFORM', 'REPORTER', 'DEFECT_CATEGORY', 'PRIORITY', 'STATUS', 'ASSIGNEE', 'ACTION'];
    }
    else {
        HEADER = ['DEFECT_ID', 'REPORTED_ON', 'DAYS_OPEN', 'WEBFORM', 'REPORTER', 'DEFECT_CATEGORY', 'PRIORITY', 'STATUS', 'ACTION'];
    }

    useEffect(() => {
        if (defectId) {
            setOpenModal(true)
        }
    }, [defectId])

    return (
        <Fragment>
            <DefectManagementTable>
                <Thead style={{ background: '#e2e2e2' }}>
                    <Tr>
                        {HEADER.map(key => (
                            <Th key={key}>{header[key]}</Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody>
                    {data &&
                        data.map((defect, index) => (
                            <Row key={defect.id} index={index} defect={defect} selectedDefect={(selected) => {
                                setSelectedDefect(selected);
                                onDefectSelected(selected)
                            }}
                                openModal={setOpenModal} userProfile={userProfile} />
                        ))}
                </Tbody>
            </DefectManagementTable>
            <ModalCustom open={openModal} setOpen={() => {
                setOpenModal(false);
                setFetchData(true);
                setSelectedDefect({});
                onDefectSelected({})
            }} header={VIEW_DEFECT} customStyles={customStyles}>
                <DefectSummary setFetchData={setFetchData} defectId={defectId} openModal={setOpenModal} defect={selectedDefect} userProfile={userProfile} />
            </ModalCustom>
        </Fragment>
    );
};

Table.propTypes = {
    data: PropTypes.objectOf(PropTypes.array).isRequired,
    header: PropTypes.objectOf(PropTypes.any).isRequired,
    setFetchData: PropTypes.func.isRequired
};

export default Table;
